import React from "react";
import {store} from "../index";
import * as actions from "../actions";

export const DEFAULT_ALERT_TIMEOUT = 1.5 * 1000;

export const addAlertWithTimeout = (data, timeout = DEFAULT_ALERT_TIMEOUT) => {
    if (!data.id) data.id = Date.now();
    store.dispatch(actions.alerts.addAlert(data));
    setTimeout(() =>  {
        store.dispatch(actions.alerts.removeAlert(data.id))
    }, timeout);
};


export const addErrorAlert = (msg, timeout = DEFAULT_ALERT_TIMEOUT) => {
    if (!msg) msg = "There was an error.";
    addAlertWithTimeout({
        type: 'danger',
        title: 'Error',
        body: msg
    }, timeout);
}

export const addSuccessAlert = (msg, timeout  = DEFAULT_ALERT_TIMEOUT) => {
    if (!msg) msg = "Success";
    addAlertWithTimeout({
        type: 'success',
        title: '',
        body: msg
    }, timeout);
}


export const addLoadingAlert = () => {
    store.dispatch(actions.alerts.addAlert({
        id: 'loader',
        // type: 'success',
        body: <div className="flx is-size-4 is-align-content-center has-text-weight-semibold has-text-primary">
            <div className="pacefi-hex-spinner small mr-3 mt-1"/>
            Loading...</div>,
        title: null
    }));
};


export const removeLoadingAlert = () => {
    store.dispatch(actions.alerts.removeAlert('loader'));
}


export const toggleGlobalLoader = (bool) => {
    store.dispatch(actions.session.toggleGlobalLoader(bool))
}


export const clearAllAlerts = (includingSticky=false) => {
    // store.dispatch(actions.alerts.clearAllAlerts())
    if(includingSticky) {
        store.dispatch(actions.alerts.clearAllAlerts())
    } else {
        store.dispatch(actions.alerts.clearAllNotStickyAlerts())
    }
}




